// extracted by mini-css-extract-plugin
export default {"flexWrapper":"WasteTypeCell_flexWrapper__ojMw1","circle":"WasteTypeCell_circle__0P5nK"};